import { t } from "i18next";
import { Dropdown, Typography } from "neetoui";
import { Trans } from "react-i18next";

const LeftActionBlock = ({
  selectedCount,
  totalCount,
  setIsResetModalOpen,
  setCurrentKeys,
  selectedRowIds,
}) => {
  const { Menu, MenuItem } = Dropdown;

  return (
    !!totalCount && (
      <>
        {selectedCount > 0 ? (
          <>
            <Typography
              className="me-4 font-semibold"
              component="h4"
              data-testid="item-count"
            >
              <Trans
                i18nKey="neetoMolecules.taxonomy.actionBlock.selectedTaxonomy"
                values={{ count: selectedCount, totalCount }}
                components={{
                  span: <span className="neeto-ui-text-gray-600" />,
                }}
              />
            </Typography>
            <Dropdown
              buttonStyle="secondary"
              label={t("neetoMolecules.taxonomy.actionBlock.takeAction")}
            >
              <Menu>
                <MenuItem.Button
                  style="secondary"
                  onClick={() => {
                    setCurrentKeys(selectedRowIds);
                    setIsResetModalOpen(true);
                  }}
                >
                  {t("neetoMolecules.common.actions.resetToDefaults")}
                </MenuItem.Button>
              </Menu>
            </Dropdown>
          </>
        ) : (
          <Typography
            className="me-4 font-semibold"
            component="h4"
            data-testid="item-count"
          >
            {t("neetoMolecules.taxonomy.actionBlock.taxonomyWithCount", {
              count: totalCount,
            })}
          </Typography>
        )}
      </>
    )
  );
};

export default LeftActionBlock;
